import { useState, useEffect } from "react";
import API from "../api";
import Select from "react-select";

function CreatePurchaseModal({ onClose, refreshPurchases }) {

  const today = new Date().toISOString().split("T")[0];

  const [vendorId, setVendorId] = useState("");
  const [purchaseDate, setPurchaseDate] = useState(today);
  const [vendors, setVendors] = useState([]);
  const [sheets, setSheets] = useState([]);

  const [sheetId, setSheetId] = useState("");
  const [quantity, setQuantity] = useState("");
  const [items, setItems] = useState([]);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    API.get("order/purchase/get-vendors/").then(res => setVendors(res.data));
    API.get("inventory/get-inventory/").then(res => setSheets(res.data));
  }, []);

  /* ================= ADD ITEM ================= */

  const addItem = () => {

    let newErrors = {};

    if (!sheetId) newErrors.sheet = "Sheet required";
    if (!quantity || quantity <= 0) newErrors.quantity = "Enter valid quantity";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    const sheet = sheets.find(s => s.id == sheetId);

    const existingIndex = items.findIndex(
      item => item.sheet_id == sheetId
    );

    if (existingIndex !== -1) {
      const updated = [...items];
      updated[existingIndex].quantity_sheets =
        parseInt(updated[existingIndex].quantity_sheets) +
        parseInt(quantity);
      setItems(updated);
    } else {
      setItems([
        ...items,
        {
          sheet_id: sheetId,
          sheet_name: sheet.name,
          quantity_sheets: quantity
        }
      ]);
    }

    // 🔥 Reset after adding
    setSheetId("");
    setQuantity("");
    setErrors({});
  };

  /* ================= REMOVE ITEM ================= */

  const removeItem = (index) => {
    const updated = [...items];
    updated.splice(index, 1);
    setItems(updated);

    // 🔥 Reset sheet dropdown (optional UX)
    setSheetId("");
  };

  /* ================= SAVE PURCHASE ================= */

  const savePurchase = async () => {

    let newErrors = {};

    if (!vendorId) newErrors.vendor = "Vendor required";
    if (!purchaseDate) newErrors.date = "Date required";
    if (items.length === 0) newErrors.items = "Add at least one item";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    await API.post("order/purchase/create-purchase/", {
      vendor_id: vendorId,
      purchase_date: purchaseDate,
      items: items
    });

    refreshPurchases();
    onClose();
  };

  /* ================= SELECT STYLES ================= */

  const customStyles = {
    control: (base) => ({
      ...base,
      borderColor:
        errors.vendor || errors.sheet ? "red" : base.borderColor,
      minHeight: "38px"
    })
  };

  return (
    <div className="modal fade show d-block">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">

          <div className="modal-header">
            <h6>New Purchase</h6>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">

            {/* ===== Vendor + Date ===== */}

            <div className="row g-3 mb-3">

              <div className="col-md-4">
                <Select
                  options={vendors.map(v => ({
                    value: v.id,
                    label: v.name
                  }))}
                  value={
                    vendors
                      .filter(v => v.id == vendorId)
                      .map(v => ({ value: v.id, label: v.name }))[0] || null
                  }
                  onChange={(selected) =>
                    setVendorId(selected ? selected.value : "")
                  }
                  placeholder="Select Vendor"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: errors.vendor ? "red" : base.borderColor
                    })
                  }}
                />
                {errors.vendor && (
                  <small className="text-danger">{errors.vendor}</small>
                )}
              </div>

              <div className="col-md-3">
                <input
                  type="date"
                  className={`form-control ${errors.date ? "is-invalid" : ""}`}
                  value={purchaseDate}
                  onChange={e => setPurchaseDate(e.target.value)}
                />
                {errors.date && (
                  <div className="invalid-feedback d-block">
                    {errors.date}
                  </div>
                )}
              </div>

            </div>

            <hr />

            {/* ===== Add Line ===== */}

            <div className="row g-3 align-items-end mb-3">

              <div className="col-md-4">
                <Select
                  options={sheets.map(s => ({
                    value: s.id,
                    label: s.name
                  }))}
                  value={
                    sheets
                      .filter(s => s.id == sheetId)
                      .map(s => ({ value: s.id, label: s.name }))[0] || null
                  }
                  onChange={(selected) =>
                    setSheetId(selected ? selected.value : "")
                  }
                  placeholder="Select Sheet"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: errors.sheet ? "red" : base.borderColor
                    })
                  }}
                />
                {errors.sheet && (
                  <small className="text-danger">{errors.sheet}</small>
                )}
              </div>

              <div className="col-md-2">
                <input
                  type="number"
                  className={`form-control ${errors.quantity ? "is-invalid" : ""}`}
                  placeholder="Qty"
                  value={quantity}
                  onChange={e => setQuantity(e.target.value)}
                />
                {errors.quantity && (
                  <div className="invalid-feedback d-block">
                    {errors.quantity}
                  </div>
                )}
              </div>

              <div className="col-md-2">
                <button
                  className="btn btn-success w-100"
                  onClick={addItem}
                >
                  Add
                </button>
              </div>

            </div>

            {errors.items && (
              <div className="text-danger mb-2">
                {errors.items}
              </div>
            )}

            {/* ===== Items Table ===== */}

            {items.length > 0 && (
              <table className="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Sheet</th>
                    <th>Qty</th>
                    <th width="80">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => (
                    <tr key={index}>
                      <td>{item.sheet_name}</td>
                      <td>{item.quantity_sheets}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => removeItem(index)}
                        >
                          ✕
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary btn-sm" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary btn-sm" onClick={savePurchase}>
              Save
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default CreatePurchaseModal;
